export default "__VITE_ASSET__BrqNlyeB__"